import ApplicationController from 'javascript/controllers/application_controller';
import { fire } from 'javascript/utils/fire';

export default class extends ApplicationController {
  static targets = ['countrySelected', 'countryFieldsData', 'bankName'];

  get formUrl() {
    return this.data.get('form-url');
  }
  onFetchCountryFieldsDataSuccess = (response) => {
    this.countryFieldsDataTarget.innerHTML = response.activeElement.innerHTML;
    if (this.hasbankNameTarget) {
      fire(this.countrySelectedTarget, 'howler:bank_details.reload');
    }
  };

  onFetchCountryFieldsDataError = (response) => {
    this.countryFieldsDataTarget.innerHTML = response;
  };

  onCountryChange() {
    this.countryFieldsDataTarget.innerHTML = 'loading..';

    $.get(
      `${this.formUrl}&country_code=${this.countrySelectedTarget.value}&type=TransferwiseBankAccount`,
    )
      .then((response) => {
        this.onFetchCountryFieldsDataSuccess({
          activeElement: { innerHTML: response },
        });
      })
      .catch((response) => {
        this.onFetchCountryFieldsDataError({
          activeElement: { innerHTML: response },
        });
      });
  }

  connect() {
    this.onCountryChange();
  }
}
